/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ColorSegment {
    getFixupPrototypeFunction() { return ColorSegment.fixupPrototype; }

    static newInstance(model: Partial<ColorSegment>): ColorSegment {
        let obj = Object.assign(new ColorSegment(), model);
        ColorSegment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ColorSegment>): ColorSegment {
        if (!model) return null;
        return ColorSegment.newInstance(<ColorSegment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ColorSegment) {
        if (!obj) return;

        models.ColorSegment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ColorSegment): boolean {
        Object.setPrototypeOf(obj, ColorSegment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.stopPointValue === undefined) {
            this.stopPointValue = 0;
        }
    }

    color: string;

    stopPoint: models.ColorStopPoint;

    stopPointValue: number;

}
